const header = [
  {
    name: '订单数',
    value: 0,
    company: '万单'
  }, {
    name: '物流金融授信金额',
    value: 0,
    company: '亿元'
  }, {
    name: '货运量',
    value: 0,
    company: '万吨'
  }, {
    name: '全市物流总额',
    value: 0,
    company: '亿元'
  }, {
    name: '交易额',
    value: 0,
    company: '亿元'
  }, {
    name: '新增物流企业',
    value: 0,
    company: '家'
  }
]

const center = [
  // {
  //   name: '交易额',
  //   value: 0,
  //   company: '亿元'
  // }, {
  //   name: '月同比增长',
  //   value: 0,
  //   company: '%'
  // }, {
  //   name: '订单数',
  //   value: 0,
  //   company: '万单'
  // }, {
  //   name: '授信金额',
  //   value: 0,
  //   company: '亿元'
  // }, {
  //   name: '上游企业数',
  //   value: 0,
  //   company: '家'
  // }, {
  //   name: '下游商家数',
  //   value: 0,
  //   company: '家'
  // }

  {
    name: '交易额',
    value: 0,
    company: '万元'
  }, {
    name: '授信金额',
    value: 0,
    company: '万元'
  }, {
    name: '上游企业数',
    value: 0,
    company: '家'
  }, {
    name: '下游商家数',
    value: 0,
    company: '家'
  }, {
    name: '平台交易额',
    value: 0,
    company: '万元'
  }, {
    name: '平台授信额',
    value: 0,
    company: '万元'
  }
]

const foot = {
  left: { // 最大六位数，无小数点
    data: [
      ['五彩缤纷路小鱼匠烤鱼啤酒', '500000']
    ],
    oddRowBGC: '',
    evenRowBGC: '',
    index: true,
    columnWidth: [25, 0, 60],
    align: ['center', '', 'right'],
  },
  right: {
    header: ['店铺', '金额(元)'],
    data: [
      ['五彩缤纷路小鱼匠烤鱼啤酒', '258.55']
    ],
    headerBGC: '',
    oddRowBGC: '',
    evenRowBGC: '',
    columnWidth: [0, 80],
    align: ['', 'right'],
  }
}

export {
  header,
  center,
  foot
}
